/**
 * 2019-04-09
 * handan
 * 背调记录数据
 */

import { ajax } from "../utils/http/http";
import handleError from "../utils/handleError";

const getResultDetail = async (params) => {
  const { recordId } = params;
  let data = await ajax(`/58/record/finJudicialDetail/${recordId}`,"POST",params)
  if(data.code === "1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}

const getResultDetailNew = async (params) => {
  const { batchId, record } = params ;
  let data = await ajax(`/58/record/result/${batchId}/${record}`)
  if(data.code === "1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}

const repeat = async (authId) => {
  let data = await ajax(`/58/batch/repeat/${authId}`,"POST")
  if(data.code === "1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}


const update = async (authId,phoneNo) => {
  let data = await ajax(`/58/batch/update`,"POST", {authId, phoneNo})
  if(data.code === "1"){
    return Promise.resolve(data.data)
  }else{
    return handleError(data);
  }
}



export {
  getResultDetail,
  getResultDetailNew,
  repeat,
  update,
};